import { SortOrder } from '@/enums/SortOrder';
import qs from 'qs';
import { Module, ActionTree, MutationTree, GetterTree } from 'vuex';

const initialState: AccountState = {
  all: [],
  viewing: undefined,
};

const getters: GetterTree<AccountState, RootState> = {
  all(state: AccountState): PimAccount[] {
    return state.all;
  },
  viewing(state: AccountState): PimAccount | undefined {
    return state.viewing;
  },
};

const mutations: MutationTree<AccountState> = {
  RESET(state: AccountState) {
    state.all = [];
    state.viewing = undefined;
  },
  UPDATE_MODEL(state: AccountState, payload: PimAccount) {
    const index = state.all.findIndex((model: PimAccount) => model.id === payload.id);

    if (index === -1) {
      state.all.push(payload);
    } else {
      state.all[index] = payload;
    }
  },
  ADD_MODEL(state: AccountState, payload: PimAccount) {
    state.all.push(payload);
  },
  ADD_MODELS(state: AccountState, payload: PimAccount[]) {
    state.all = [...state.all, ...payload];
  },
  SET_MODELS(state: AccountState, payload: PimAccount[]) {
    state.all = payload;
  },
  SET_VIEWING(state: AccountState, payload: PimAccount) {
    state.viewing = payload;
  },
};

const actions: ActionTree<AccountState, RootState> = {
  index({ commit, rootState }, payload: { query?: IndexQuery<PimAccount> } = { query: { s: { created_at: SortOrder.DESC, id: SortOrder.ASC }, per_page: 20 } }) {
    const queryString = qs.stringify(payload.query, { encode: false });

    return rootState.api
      .get(`api/accounts?${queryString}`, { withCredentials: true })
      .then((response: { data: PimAccount }) => {
        if (payload.query?.hasOwnProperty('after')) {
          commit('ADD_MODELS', response.data);
        } else {
          commit('SET_MODELS', response.data);
        }

        return Promise.resolve(response.data);
      })
      .catch((e: ErrorResponse) => {
        return Promise.reject(e);
      });
  },
  read({ commit, rootState }, payload: { id: number }) {
    return rootState.api
      .get(`api/accounts/${payload.id}`, { withCredentials: true })
      .then((response: { data: PimAccount }) => {
        commit('UPDATE_MODEL', response.data);

        commit('SET_VIEWING', response.data);

        return Promise.resolve(response.data);
      })
      .catch((e: ErrorResponse) => {
        return Promise.reject(e);
      });
  },
  update({ commit, rootState }, payload: PimAccount) {
    return rootState.api
      .put(`api/accounts/${payload.id}`, payload, { withCredentials: true })
      .then((response: { data: PimAccount }) => {
        commit('UPDATE_MODEL', response.data);

        return Promise.resolve(response.data);
      })
      .catch((e: ErrorResponse) => {
        return Promise.reject(e);
      });
  },
  patch({ commit, rootState }, {id, data}: {id: number, data: Partial<PimAccountData>}) {
    return rootState.api
      .patch(`api/accounts/${id}`, data, { withCredentials: true })
      .then((response: { data: PimAccount }) => {
        commit('UPDATE_MODEL', response.data);

        return Promise.resolve(response.data);
      })
      .catch((e: ErrorResponse) => {
        return Promise.reject(e);
      });
  },
  create({ commit, rootState }, payload: PimAccount) {
    return rootState.api
      .post(`api/accounts`, payload, { withCredentials: true })
      .then((response: { data: PimAccount }) => {
        commit('ADD_MODEL', response.data);

        return Promise.resolve(response.data);
      })
      .catch((e: ErrorResponse) => {
        return Promise.reject(e);
      });
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
